// extracted by mini-css-extract-plugin
export default {"productDescription":"K--z","featuredDescription":"L--z","description":"M--z","more":"N--z","descriptionSku":"O--z"};